import React, { useEffect } from "react";
import Reveal from "@/components/marketing/Reveal";

export function usePageMeta(title, description) {
  useEffect(() => {
    document.title = `${title} — Recovers Crypto`;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (m) m.setAttribute("content", description);
    }
  }, [title, description]);
}

export default function PageHero({ eyebrow, title, subtitle, children }) {
  return (
    <section className="relative overflow-hidden rc-ambient border-b border-white/10">
      <div className="absolute inset-0 rc-grid-lines opacity-40" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20 sm:py-24">
        <Reveal>
          {eyebrow && <p className="text-xs uppercase tracking-[0.2em] font-semibold text-cyanx mb-3">{eyebrow}</p>}
          <h1 className="font-heading text-4xl sm:text-5xl font-light tracking-tight text-white max-w-3xl">{title}</h1>
          {subtitle && <p className="mt-5 text-lg text-slate-300 max-w-2xl leading-relaxed">{subtitle}</p>}
          {children}
        </Reveal>
      </div>
    </section>
  );
}
